module.exports = __webpack_public_path__ + "media/send-message.3637869f.mp3";